import { STATUS } from "./status";

// Interactive navigation tool — no case study page. The work index card links
// straight out to the live product, so this module carries meta only.
const geoTool = {
  meta: {
    key: "geoTool",
    layout: "external",
    title: "Interactive navigation tool",
    status: STATUS.LIVE,
    desc: "An interactive geographic navigation tool, enabling users to explore locations across Egypt through an intuitive zoom-and-click interface",
    url: "https://sodic.public.sakneen.com/search/map/public#7.24/30.296/30.299",
    cover: "/assets/geo-tool/banner.webp",
  },
};

export default geoTool;
